import { imageFile } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

const Item = (props) => {
  const { item, settings } = props;
  const currency = currencyFormat(item.price, settings);
  return (
    <div>
      <div className="c7-cart-items__quantity">{item.quantity} bottle(s)</div>
      <div className="c7-cart-items__image">
        <img src={imageFile(item.image, 'small')} alt={item.productTitle} />
      </div>
      <div className="c7-cart-items__title">
        {item.productTitle}
        <div className="c7-cart-items__title__variant">
          {item.productVariantTitle}
        </div>
        {item.shipDate && (
          <div className="c7-cart-items__item-ship-date">
            Next release ships {item.shipDate}
          </div>
        )}
        {!item.shipDate && (
          <div className="c7-cart-items__item-ship-date">&nbsp;</div>
        )}
      </div>
      <div className="c7-cart-items__price" aria-label="Unit price">
        {currency.split('.')[0]} each
      </div>
      {/* <div className="c7-cart-items__item-total">
        {currencyFormat(item.price * item.quantity, settings)}
      </div> */}
    </div>
  );
};

export default Item;
